import { useEffect } from "react";

/**
 * A landing nasce depois do carregamento, entao o navegador nao acha a secao de
 * um link como `/#recursos` vindo de outra pagina. A rolagem e feita aqui.
 */
export function useRolarParaAncora() {
  useEffect(() => {
    const id = window.location.hash.slice(1);
    if (id) document.getElementById(id)?.scrollIntoView();
  }, []);
}
